import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "error" }
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "error" }
const _hoisted_17 = { class: "col-sm-12" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "error" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-sm-4" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = {
  key: 1,
  class: "col-sm-4"
}
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "checkbox" }
const _hoisted_32 = {
  key: 0,
  class: "row"
}
const _hoisted_33 = { class: "col-sm-4" }
const _hoisted_34 = { class: "col-sm-4" }
const _hoisted_35 = {
  key: 1,
  class: "row"
}
const _hoisted_36 = { class: "col-sm-4" }
const _hoisted_37 = { class: "col-sm-4" }
const _hoisted_38 = { class: "col-sm-4" }
const _hoisted_39 = {
  key: 2,
  class: "row"
}
const _hoisted_40 = { class: "col-sm-4" }
const _hoisted_41 = { class: "col-sm-4" }
const _hoisted_42 = {
  key: 3,
  class: "row"
}
const _hoisted_43 = { class: "col-sm-4" }
const _hoisted_44 = { class: "col-sm-4" }
const _hoisted_45 = { class: "mt-3" }
const _hoisted_46 = {
  key: 0,
  class: "dropdown d-inline"
}
const _hoisted_47 = {
  class: "dropdown-menu",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 1,
  class: "dropdown d-inline"
}
const _hoisted_50 = {
  class: "dropdown-menu",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "row mt-3" }
const _hoisted_53 = { class: "col-sm-4" }
const _hoisted_54 = {
  class: "row",
  style: {"margin-top":"5px"}
}
const _hoisted_55 = { class: "col-sm-3" }
const _hoisted_56 = ["onUpdate:modelValue"]
const _hoisted_57 = { class: "col-sm-4" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = { key: 1 }
const _hoisted_61 = ["onUpdate:modelValue"]
const _hoisted_62 = { key: 2 }
const _hoisted_63 = { key: 3 }
const _hoisted_64 = ["onUpdate:modelValue"]
const _hoisted_65 = { class: "col-sm-4" }
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = { class: "col-sm-1" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "error" }
const _hoisted_70 = { class: "d-flex justify-content-end" }
const _hoisted_71 = { class: "dropdown" }
const _hoisted_72 = {
  class: "dropdown-menu dropdown-menu-right",
  style: {"overflow-y":"auto","max-height":"400px"}
}
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "form-group" }
const _hoisted_75 = { class: "error" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { class: "shadow-none p-3 mb-3 bg-light rounded" }
const _hoisted_78 = { class: "form-inline" }
const _hoisted_79 = ["onUpdate:modelValue"]
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-sm-6" }
const _hoisted_82 = { class: "col-sm-6" }
const _hoisted_83 = { style: {"margin":"0"} }
const _hoisted_84 = { class: "modal-footer" }
const _hoisted_85 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_ctx.opened)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.dialogTitle), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                (!_ctx.initialized)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_8, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (_ctx.initialized)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("form", {
                        id: "attribute-editor-dialog-form",
                        onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _cache[23] || (_cache[23] = _createElementVNode("label", null, [
                                _createElementVNode("span", { class: "text-danger" }, "*"),
                                _createTextVNode(" Name")
                              ], -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                                type: "text",
                                class: "form-control",
                                required: "",
                                minlength: "2",
                                maxlength: "100"
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  _ctx.name,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              _cache[24] || (_cache[24] = _createElementVNode("small", null, "Name of the attribute", -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.nameError), 1 /* TEXT */)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _cache[25] || (_cache[25] = _createElementVNode("label", null, "Section", -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.section) = $event)),
                                class: "form-control",
                                maxlength: "100"
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  _ctx.section,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              _cache[26] || (_cache[26] = _createElementVNode("small", null, "Name of the section. Use sections to group attributes e.g. financials.", -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.sectionError), 1 /* TEXT */)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _cache[27] || (_cache[27] = _createElementVNode("label", null, "Description", -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event)),
                                type: "text",
                                class: "form-control",
                                rows: "3",
                                maxlength: "500"
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  _ctx.description,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              _cache[28] || (_cache[28] = _createElementVNode("small", null, "Description of the attribute.", -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.descriptionError), 1 /* TEXT */)
                            ])
                          ])
                        ]),
                        _cache[57] || (_cache[57] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _cache[30] || (_cache[30] = _createElementVNode("label", null, "Type", -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("select", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.attributeType) = $event)),
                                disabled: !_ctx.allowChangeAttributeType,
                                required: ""
                              }, [...(_cache[29] || (_cache[29] = [
                                _createStaticVNode("<option value=\"Real\">Numeric</option><option value=\"Text\">Text</option><option value=\"MultilineText\">Multiline text</option><option value=\"Date\">Date</option><option value=\"Email\">Email</option>", 5)
                              ]))], 8 /* PROPS */, _hoisted_23), [
                                [_vModelSelect, _ctx.attributeType]
                              ])
                            ])
                          ]),
                          (_ctx.attributeType === 'Real')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                  _cache[33] || (_cache[33] = _createElementVNode("label", null, "Input type", -1 /* CACHED */)),
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputType) = $event)),
                                    required: ""
                                  }, [
                                    _cache[31] || (_cache[31] = _createElementVNode("option", { value: "Manual" }, "Enter value manually", -1 /* CACHED */)),
                                    _cache[32] || (_cache[32] = _createElementVNode("option", { value: "List" }, "Pick value from list", -1 /* CACHED */)),
                                    _createElementVNode("option", {
                                      value: "Evaluate",
                                      disabled: _ctx.allowInputTypeEvaluate === false
                                    }, " Based on formula ", 8 /* PROPS */, _hoisted_26)
                                  ], 512 /* NEED_PATCH */), [
                                    [_vModelSelect, _ctx.inputType]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.attributeType !== 'MultilineText')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_ctx.attributeType !== 'Real')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _createElementVNode("div", _hoisted_28, [
                                        _cache[35] || (_cache[35] = _createElementVNode("label", null, "Input type", -1 /* CACHED */)),
                                        _withDirectives(_createElementVNode("select", {
                                          class: "form-control",
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputType) = $event))
                                        }, [...(_cache[34] || (_cache[34] = [
                                          _createElementVNode("option", { value: "Manual" }, "Enter value manually", -1 /* CACHED */),
                                          _createElementVNode("option", { value: "List" }, "Pick value from list", -1 /* CACHED */)
                                        ]))], 512 /* NEED_PATCH */), [
                                          [_vModelSelect, _ctx.inputType]
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                (_ctx.allowMultipleValuesEnabled === true && _ctx.inputType !== 'Evaluate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      _createElementVNode("div", _hoisted_30, [
                                        _cache[37] || (_cache[37] = _createElementVNode("label", null, "Multi-select", -1 /* CACHED */)),
                                        _createElementVNode("div", _hoisted_31, [
                                          _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isMultivalue) = $event)),
                                              type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                              [_vModelCheckbox, _ctx.isMultivalue]
                                            ]),
                                            _cache[36] || (_cache[36] = _createTextVNode(" Allow multiple values ", -1 /* CACHED */))
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _cache[58] || (_cache[58] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        (_ctx.inputType === 'Manual')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.attributeType === 'Text')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                      _cache[38] || (_cache[38] = _createElementVNode("label", null, "Min length", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.minLength) = $event)),
                                        type: "number",
                                        class: "form-control",
                                        min: "0",
                                        step: "1"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          _ctx.minLength,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                      _cache[39] || (_cache[39] = _createElementVNode("label", null, "Max length", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.maxLength) = $event)),
                                        type: "number",
                                        class: "form-control",
                                        min: "1",
                                        step: "1"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          _ctx.maxLength,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (_ctx.attributeType === 'MultilineText')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createElementVNode("div", _hoisted_36, [
                                      _cache[40] || (_cache[40] = _createElementVNode("label", null, "Min length", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.minLength) = $event)),
                                        type: "number",
                                        class: "form-control",
                                        min: "0",
                                        step: "1"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          _ctx.minLength,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                      _cache[41] || (_cache[41] = _createElementVNode("label", null, "Max length", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.maxLength) = $event)),
                                        type: "number",
                                        class: "form-control",
                                        min: "1",
                                        step: "1"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          _ctx.maxLength,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_38, [
                                      _cache[42] || (_cache[42] = _createElementVNode("label", null, "Number of lines", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.rows) = $event)),
                                        type: "number",
                                        class: "form-control",
                                        min: "0",
                                        step: "1"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          _ctx.rows,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (_ctx.attributeType === 'Real')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                      _cache[43] || (_cache[43] = _createElementVNode("label", null, "Min value", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.minValue) = $event)),
                                        type: "number",
                                        class: "form-control"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          _ctx.minValue,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_41, [
                                      _cache[44] || (_cache[44] = _createElementVNode("label", null, "Max value", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.maxValue) = $event)),
                                        type: "number",
                                        class: "form-control"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          _ctx.maxValue,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (_ctx.attributeType === 'Date')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _cache[45] || (_cache[45] = _createElementVNode("label", null, "Min value", -1 /* CACHED */)),
                                      _createVNode(_component_DatePicker, {
                                        value: _ctx.minDate,
                                        onChange: _ctx.onMinDateChanged
                                      }, null, 8 /* PROPS */, ["value", "onChange"])
                                    ]),
                                    _createElementVNode("div", _hoisted_44, [
                                      _cache[46] || (_cache[46] = _createElementVNode("label", null, "Max value", -1 /* CACHED */)),
                                      _createVNode(_component_DatePicker, {
                                        value: _ctx.maxDate,
                                        onChange: _ctx.onMaxDateChanged
                                      }, null, 8 /* PROPS */, ["value", "onChange"])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (_ctx.inputType === 'List')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("button", {
                                  class: "btn btn-sm btn-outline-secondary mr-1",
                                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addDefinedValue && _ctx.addDefinedValue(...args)))
                                }, "Add value"),
                                (_ctx.attributeType === 'Real')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                      _cache[47] || (_cache[47] = _createElementVNode("button", {
                                        class: "btn btn-sm btn-outline-secondary dropdown-toggle",
                                        "data-toggle": "dropdown"
                                      }, " Scales templates ", -1 /* CACHED */)),
                                      _createElementVNode("div", _hoisted_47, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scales, (s) => {
                                          return (_openBlock(), _createElementBlock("a", {
                                            key: s.Id,
                                            class: "dropdown-item",
                                            onClick: ($event: any) => (_ctx.definedValues = s.Levels)
                                          }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_48))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ])
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                (_ctx.attributeType === 'Email')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                      _cache[49] || (_cache[49] = _createElementVNode("button", {
                                        class: "btn btn-sm btn-outline-secondary dropdown-toggle",
                                        "data-toggle": "dropdown"
                                      }, " Add from People ", -1 /* CACHED */)),
                                      _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleLoadEmailDefinedValuesByPeopleTag(null)))
                                        }, "All"),
                                        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.peopleTags, (t) => {
                                          return (_openBlock(), _createElementBlock("a", {
                                            class: "dropdown-item",
                                            key: t,
                                            onClick: ($event: any) => (_ctx.handleLoadEmailDefinedValuesByPeopleTag(t))
                                          }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_51))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ])
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("div", _hoisted_52, [
                                _cache[50] || (_cache[50] = _createElementVNode("div", { class: "col-sm-3" }, [
                                  _createElementVNode("label", null, "Name")
                                ], -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("label", null, _toDisplayString(_ctx.attributeType !== 'Email' ? 'Value' : 'Email'), 1 /* TEXT */)
                                ]),
                                _cache[51] || (_cache[51] = _createElementVNode("div", { class: "col-sm-4" }, [
                                  _createElementVNode("label", null, "Description")
                                ], -1 /* CACHED */))
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.definedValues, (dv) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((dv.Name) = $event),
                                        class: "form-control",
                                        required: "",
                                        minlength: "2",
                                        maxlength: "100"
                                      }, null, 8 /* PROPS */, _hoisted_56), [
                                        [
                                          _vModelText,
                                          dv.Name,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_57, [
                                      (_ctx.attributeType === 'Text')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              "onUpdate:modelValue": ($event: any) => ((dv.Value) = $event),
                                              required: "",
                                              class: "form-control"
                                            }, null, 8 /* PROPS */, _hoisted_59), [
                                              [
                                                _vModelText,
                                                dv.Value,
                                                void 0,
                                                { trim: true }
                                              ]
                                            ])
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      (_ctx.attributeType === 'Real')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              "onUpdate:modelValue": ($event: any) => ((dv.Value) = $event),
                                              required: "",
                                              class: "form-control"
                                            }, null, 8 /* PROPS */, _hoisted_61), [
                                              [
                                                _vModelText,
                                                dv.Value,
                                                void 0,
                                                { number: true }
                                              ]
                                            ])
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      (_ctx.attributeType === 'Date')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                            _createVNode(_component_DatePicker, {
                                              value: dv.Value != null ? new Date(dv.Value) : null,
                                              onChange: ($event: any) => (_ctx.onDefinedLevelDateChanged($event, dv))
                                            }, null, 8 /* PROPS */, ["value", "onChange"])
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      (_ctx.attributeType === 'Email')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "email",
                                              "onUpdate:modelValue": ($event: any) => ((dv.Value) = $event),
                                              required: "",
                                              class: "form-control"
                                            }, null, 8 /* PROPS */, _hoisted_64), [
                                              [
                                                _vModelText,
                                                dv.Value,
                                                void 0,
                                                { trim: true }
                                              ]
                                            ])
                                          ]))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_65, [
                                      _withDirectives(_createElementVNode("textarea", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((dv.Description) = $event),
                                        class: "form-control",
                                        rows: "2"
                                      }, null, 8 /* PROPS */, _hoisted_66), [
                                        [
                                          _vModelText,
                                          dv.Description,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_67, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.removeDefinedValue(dv)),
                                        class: "btn btn-outline-secondary"
                                      }, [...(_cache[52] || (_cache[52] = [
                                        _createElementVNode("i", { class: "fa fa-times-circle" }, null, -1 /* CACHED */)
                                      ]))], 8 /* PROPS */, _hoisted_68)
                                    ])
                                  ])
                                ]))
                              }), 256 /* UNKEYED_FRAGMENT */)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.definedValuesErrors, (e) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  _createElementVNode("div", _hoisted_69, _toDisplayString(e), 1 /* TEXT */)
                                ]))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (_ctx.inputType === 'Evaluate')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _cache[55] || (_cache[55] = _createElementVNode("label", null, "Formula", -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("div", _hoisted_71, [
                                  _cache[53] || (_cache[53] = _createElementVNode("button", {
                                    class: "btn btn-sm btn-secondary dropdown-toggle",
                                    "data-toggle": "dropdown"
                                  }, "Insert", -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_72, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numericAttributeNames, (attrName) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: attrName,
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.insertAttributeIntoScript(attrName))
                                      }, _toDisplayString(attrName), 9 /* TEXT, PROPS */, _hoisted_73))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_74, [
                                _withDirectives(_createElementVNode("textarea", {
                                  ref: "ta",
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.script) = $event)),
                                  rows: "5",
                                  class: "form-control"
                                }, null, 512 /* NEED_PATCH */), [
                                  [_vModelText, _ctx.script]
                                ]),
                                _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.scriptError), 1 /* TEXT */)
                              ]),
                              _createElementVNode("a", {
                                class: "text-primary",
                                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.testScriptPanelVisible = !_ctx.testScriptPanelVisible))
                              }, "Test formula"),
                              _cache[56] || (_cache[56] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              (_ctx.testScriptPanelVisible === true)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                    _createElementVNode("div", _hoisted_77, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scriptTestInputs, (i) => {
                                        return (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                          _createElementVNode("label", null, _toDisplayString(i.Name) + ": ", 1 /* TEXT */),
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            "onUpdate:modelValue": ($event: any) => ((i.Value) = $event),
                                            class: "form-control",
                                            style: {"width":"90px"}
                                          }, null, 8 /* PROPS */, _hoisted_79), [
                                            [
                                              _vModelText,
                                              i.Value,
                                              void 0,
                                              { number: true }
                                            ]
                                          ])
                                        ]))
                                      }), 256 /* UNKEYED_FRAGMENT */)),
                                      _cache[54] || (_cache[54] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                      _createElementVNode("div", _hoisted_80, [
                                        _createElementVNode("div", _hoisted_81, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleLoadScriptTestResult && _ctx.handleLoadScriptTestResult(...args))),
                                            class: "btn btn-outline-secondary"
                                          }, "Test")
                                        ]),
                                        _createElementVNode("div", _hoisted_82, [
                                          _createElementVNode("h3", _hoisted_83, " Result: " + _toDisplayString(_ctx.scriptTestResult), 1 /* TEXT */)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ], 32 /* NEED_HYDRATION */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("button", {
                  type: "submit",
                  form: "attribute-editor-dialog-form",
                  disabled: !_ctx.initialized,
                  class: "btn btn-primary"
                }, _toDisplayString(_ctx.confirmButtonLabel), 9 /* TEXT, PROPS */, _hoisted_85),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}